// Export all ABI files as TypeScript objects
export { default as tablesAbi } from './tables.json';
export { default as tournamentAbi } from './tournament.json';
export { default as usdtAbi } from './usdt.json';
export { default as entryPointAbi } from './entry-point.json';
export { default as tokenFlowOrchestratorAbi } from './token-flow-orchestrator.json';
export { default as tournamentRakeManager } from './tournament-rake-manager.json';
export { default as tournamentFactoryAbi } from './tournament-factory.json';
export { default as revenueShareManagerAbi } from './revenue-share-manager.json';
export { default as rewardsManagerAbi } from './rewards-manager.json';
export { default as redemptionManagerAbi } from './redemption-manager.json';
export { default as redemptionVaultAbi } from './redemption-vault.json';
export { default as redemptionAbi } from './redemption.json';
export { default as rakeManagerAbi } from './rake-manager.json';
export { default as paymasterAbi } from './paymaster.json';
export { default as phenomTokenAbi } from './phenom-token.json';

// For backward compatibility, also export with the original names
export { default as tables } from './tables.json';
export { default as tournament } from './tournament.json';
export { default as usdt } from './usdt.json';
export { default as entryPoint } from './entry-point.json';
